import css from './accordion.module.css'
import type { AccordionVariant } from './accordion.types'

export const styles = {
  base: css.accordion,
}

export const variantStyles: Record<AccordionVariant, string> = {
  white: css.variantWhite,
  'light-2': css.variantLight2,
  dark: css.variantDark,
}
